import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Quill from "react-quill";
import {storage} from "../firebase";

import "react-quill/dist/quill.snow.css";


class DishForm extends Component {
  state = {
    dish: {
      key: this.props.dish.key,
      slug: this.props.dish.slug,
      title: this.props.dish.title,
      content: this.props.dish.content,
      date: this.props.dish.date,
      image: this.props.dish.image,
      imgUrl: this.props.dish.imgUrl,
    },
    progress: 0,
    //value for saved to state, false by default
    saved: false,
  };

  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dish.key !== this.props.dish.key) {
      this.setState({
        dish: {
          key: this.props.dish.key,
          slug: this.props.dish.slug,
          title: this.props.dish.title,
          content: this.props.dish.content,
          date: this.props.dish.date,
          image: this.props.dish.image,
          imgUrl: this.props.dish.imgUrl,
        }
      });
    }
  };

  handleImgChange = e => {
    if (e.target.files[0]) {
      const imageFile = e.target.files[0];
      this.setState({ dish: {...this.state.dish, image: imageFile}});
    }
  };

  handleImgUpload = e => {
    e.preventDefault();
    //if image isn't undefined save image file to firebase storage and save image URL from storage to imgURL in database
    if (this.state.dish.image) {
      const { image } = this.state.dish;
      const uploadTask = storage.ref(`images/${image.name}`).put(image);
      uploadTask.on(
        "state_changed",
        snapshot => {
          // progress function ...
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({ progress });
        },
        error => {
          // Error function ...
          console.log(error);
        },
        () => {
          // code to get URL from storage and save URL in database?
          storage
            .ref("images")
            .child(image.name)
            .getDownloadURL()
            .then(fireBaseUrl => {
              this.setState({ dish: {...this.state.dish, imgUrl: fireBaseUrl}});
              console.log(fireBaseUrl);
              console.log(fireBaseUrl.toString());
            });
        }
      );
    } else {
      alert("Please click browse and select an image to upload");
    }
  };


  handleAddNewDish = e => {
    e.preventDefault();
      //requiring both title and date to be filled in
      if(this.state.dish.title && this.state.dish.date) {
        if (this.props.updateDish) {
          //if updating dish and imgUrl is not empty update dish
          if(this.state.dish.imgUrl) {
            this.props.updateDish(this.state.dish);
            console.log(this.state.dish.imgUrl);
          }
          //otherwise when imgUrl is empty set imgUrl to null then update dish
          else {
            this.setState({ dish: {...this.state.dish, imgUrl: ""}});
            this.props.updateDish(this.state.dish);
          }
        } else {
          //need new props object to add new dish/post by passing the dish/post to the addNewDish function
          //this.props.addNewDish(dish);
          this.props.addNewDish(this.state.dish);
        }
        //set state of saved to true if there is something in the title input and user has clicked submit
        this.setState({ saved: true });
      }
      
      else {
        alert("Title and date are required");
      }
  };

  render() {
    //redirect back home if post/dish was saved
    if (this.state.saved === true) {
      return <Redirect to="/" />;
    }
    return (

      <form className="container form--post d-flex flex-column" >
        <span className="icon-MadebyMade-Vector-LineIcons-Cafe-Outlined-12 text-center"></span>
        <h1 className="text-center">Add or Update a dish</h1>

          <div className="form-group form--input-group my-3">
            <label className="mb-0" htmlFor="form-title">Title: <small>(required)</small></label>
            {
                // everytime the title is changed (type in something into this input) it's setting the state
                // run the function inside the text area
                // get title from props and set it as defaultValue of the form based on value of dish.title in state
                // in onChange method set state of dish = to past value of dish in state then override dish.title with value from your form.
            }
            <input
              className="form-control form-control-lg form--text-input"
              key="form-title"
              defaultValue={this.props.title}
              value={this.state.dish.title}
              onChange={e => this.setState({ dish: {...this.state.dish, title: e.target.value}
              })
              }
            />
          </div>
          
            <div className="form-group form--input-group my-3">
              <label className="mb-0" htmlFor="form-date">Date: <small>(required)</small></label>
              <input
                className="form-control form-control-lg form--text-input"
                type="date"
                key="form-date"
                defaultValue={this.props.date}
                value={this.state.dish.date}
                onChange={e => this.setState({ dish: {...this.state.dish, date: e.target.value}
                })
                }
              />
            </div>

          <div className="form-group form--input-group my-3">
            <label className="mb-0" htmlFor="form-content">Content:</label>
            <small className="py-2">Tips: Please use Header 2 for each new section title. Only use one new line between elements</small>
            <Quill
              defaultValue={this.state.dish.content}
              onChange={(content, delta, source, editor) => {
                this.setState({ dish: {...this.state.dish, content: editor.getContents() }
                });
              }}
            />
          </div>

        {
          //reach file directory and upload image to browser
        }
        <div className="form-group form--input-group my-3">
          <label className="mb-0" htmlFor="form-img">Image:</label>  

          <div className="d-flex flex-column flex-sm-row justify-content-between w-100">
            <div className="input--file--contain flex-grow-1 ">
              <input 
                className="input--file"
                key="form-img"
                defaultValue={this.props.image}
                type="file"
                onChange={this.handleImgChange} />
            </div>
            
            <button
              onClick={this.handleImgUpload}
              className="btn btn--input--file">
              Upload Image
            </button>
          </div>  

          <div className="my-2">
            <progress value={this.state.progress} max="100" className="progress"/>
          </div>


        </div>


        <img
          className="img-fluid"
          src={this.state.dish.imgUrl || "https://via.placeholder.com/400x300"}
          alt="Uploaded Dish"
          height="auto"
          width="50%"
        />

        <div className="my-5 d-flex justify-content-start">
          <button className="btn--primary" type="submit" onClick={this.handleAddNewDish}>Save</button>
        </div>
      </form>
    );
  }
}
export default DishForm;
